import React from 'react'
import { Typography } from '@mui/material'

type SectionLabelProps = {
  children: React.ReactNode
}

export function SectionLabel({ children }: SectionLabelProps) {
  return (
    <Typography
      variant="overline"
      sx={{ display: 'block', fontWeight: 700, letterSpacing: '0.12em', color: 'text.secondary', mb: 1.5, ml: 0.5 }}
    >
      {children}
    </Typography>
  )
}
